export default __webpack_public_path__ + "static/media/OldSchoolAdventures.dc35dcc6.ttf";